import React from 'react';
import { Link } from 'react-router-dom';
import { FaChevronLeft, FaChevronUp } from 'react-icons/fa';

import { LandingContainer, ReturnButton } from '../Landing.styled';

import Content from '../../Pages/FAQ/FAQ.content';

function FAQ(): React.ReactElement {
  function goTop() {
    window.scrollTo(0, 0);
  }

  return (
    <LandingContainer className="landing-container">
      <Link to="/">
        <ReturnButton>
          <div className="icon">
            <FaChevronLeft />
          </div>
          Return Home
        </ReturnButton>
      </Link>
      <Content />
      <ReturnButton onClick={goTop}>
        <div className="icon">
          <FaChevronUp />
        </div>
        Go to top
      </ReturnButton>
    </LandingContainer>
  );
}

export default FAQ;
